import {type Institution} from './model';

export const hasBehavior = (institution: Institution, behavior: string) =>
    institution && institution.behaviors.includes(behavior);
